export default class IssueTags {
    constructor($scope, $window, $timeout) {
        'ngInject';
        this.addMenuOpen = false;
        this.searchTerm = '';
        this.$timeout = $timeout;
        $window.addEventListener('click', () => {
            this.addMenuOpen = false;
            $scope.$apply();
        });
    }

    openAddMenu($event) {
        $event.stopPropagation();
        if(!this.addMenuOpen) {
            this.searchTerm = '';
        }
        this.addMenuOpen = true;
        this.$timeout(() => {
            angular.element('issue-tags .add-input').focus();
        })
    }

    add(tag) {
        this.selected.push(tag);
        this.change();
    }

    remove(tag, $event) {
        $event.stopPropagation();
        this.selected.splice(this.selected.indexOf(tag), 1);
        this.change();
    }

    getOptions() {
        return this.values.filter(value => !this.selected.includes(value) && value.Title.includes(this.searchTerm));
    }
}



// WEBPACK FOOTER //
// ../widgets/issue-tags/issue-tags.controller.js